import React, { FC } from "react";
import { Id } from "../../../types";
import { useMachine } from "@xstate/react";
import { fetchMachine } from "../../../machines/fetch";
import { useRecoilState, useRecoilValue } from "recoil";
import { activeSubscriptionIdState, orgUnitsState } from "../../../atoms";
import { useForm } from "react-hook-form";
import {
  Button,
  FormControl,
  FormLabel,
  Select,
  Stack,
  useToast,
} from "@chakra-ui/react";
import { updateParentOrgUnit } from "../../../api/update-parent-org-unit";

type FormData = { parentOrgUnitId?: Id };

type Props = {
  id: Id;
  onSuccess: (newOrgUnitId: Id) => void;
};

export const UpdateParentOrgUnit: FC<Props> = (props) => {
  const { id } = props;

  const toast = useToast();

  const activeSubscriptionId = useRecoilValue(activeSubscriptionIdState);
  const [orgUnits, setOrgUnits] = useRecoilState(orgUnitsState);
  const orgUnit = orgUnits[id];

  const { register, handleSubmit, watch } = useForm<FormData>({
    defaultValues: { parentOrgUnitId: orgUnit.parentOrgUnitId },
  });
  const watchParentOrgUnitId = watch("parentOrgUnitId");

  const onSubmit = () => {
    send(state.matches("failure") ? "RETRY" : "FETCH");
  };

  const [state, send] = useMachine(fetchMachine, {
    services: {
      fetch: () =>
        updateParentOrgUnit({
          id: props.id,
          parentOrgUnitId: Number(watchParentOrgUnitId),
          subscriptionId: activeSubscriptionId as Id,
        }),
    },

    actions: {
      success: (_, event: any) => {
        setOrgUnits(event.data.orgUnits);
        toast({
          title: "bovenliggende organisatie-eenheid aangepast",
          status: "success",
          isClosable: true,
        });
      },

      failure: (_, event: any) => {
        toast({
          title: "aanpassen van bovenliggende organisatie-eenheid niet gelukt",
          description: JSON.stringify(event.data, null, 2),
          status: "error",
          isClosable: true,
        });
      },
    },
  });

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Stack spacing={8} align="start">
        <FormControl>
          <FormLabel>bovenliggende organisatie-eenheid</FormLabel>
          <Select
            placeholder="kies bovenliggende organisatie-eenheid"
            name="parentOrgUnitId"
            ref={register()}
          >
            {Object.values(orgUnits).map((orgUnit) => (
              <option key={orgUnit.id} value={orgUnit.id}>
                {orgUnit.name}
              </option>
            ))}
          </Select>
        </FormControl>

        <Button type="submit" size="sm" isLoading={state.matches("loading")}>
          pas aan
        </Button>
      </Stack>
    </form>
  );
};
